<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bPFqEb/tc-custom/9780830862221.jpg?1696025263135" alt="This image is the cover for the book 1 & 2 Peter and Jude, LifeGuide Bible Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">1 & 2 Peter and Jude, LifeGuide Bible Studies
      </h1>
      <p class="bookDescription body article font2">
        <p>"I'll never grow up." Sometimes we all feel a little like Peter Pan. We'd rather be children, free of obligations and responsibilities. Sometimes we even feel that way about our Christian lives. The writers of 1  2 Peter and Jude understand how difficult it is to grow into maturity. As Carolyn Nystrom leads us through these letters, we see how God provides direction and comfort when we travel dark roads. And we discover what it takes to be mature in Christ. This revised LifeGuide Bible Study features additional questions for starting group discussions and for meeting God in personal reflection, together with expanded leader's notes and a "Now or Later" section in each study. <strong>PDF download with a single-user license; available from InterVarsity Press and other resellers.</strong> </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carolyn Nystrom
      </h2>
      
      <p class="authorDescription body article"><p>Carolyn Nystrom (MA, Wheaton College) has written more than eighty books, Bible study guides and children's titles. She served as general editor for the Christian Classics series and she co-authored <em>Guard Us, Guide Us</em> and <em>Praying</em> with theologian J. I. Packer, and <em>Before I Was Born (God's Design for Sex)</em> with Sandra Speidel. In addition to actively serving in her church and community, she has been a foster parent, an elementary schoolteacher and a book editor. Carolyn lives in the Chicago area with her husband and they have four grown children.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?98f38aba